import React, { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Link, useParams, useHistory, useRouteMatch } from "react-router-dom"
import { Button, Form, Input, Row, Col, notification } from "antd"
import { LeftOutlined } from "@ant-design/icons"
import nodePath from "path"

import { fetchProductionUnit, selectProductionUnit, setProductionUnit, submitProductionUnit } from "../productionUnitsSlice"

import { requestNotification } from "../../../../lib/notifications"

export default function ProductionUnitForm({ actionName }) {
    const { url } = useRouteMatch()
    const history = useHistory()
    const [form] = Form.useForm()
    const dispatch = useDispatch()
    const productionUnit = useSelector(selectProductionUnit)
    const { productionUnitId } = useParams()

    useEffect(() => {
        if (productionUnitId) {
            dispatch(fetchProductionUnit(productionUnitId))
        } else {
            dispatch(setProductionUnit({}))
        }
    }, [dispatch, productionUnitId])

    useEffect(() => {
        form.resetFields()
    }, [form, productionUnit])

    const submit = async (values) => {
        const response = await dispatch(submitProductionUnit(values, productionUnitId))

        if (response.success) {
            actionName === "edit" ? history.push(`${nodePath.join(url, "../..")}`) : history.push(`${nodePath.join(url, "..")}`)
        }

        requestNotification(response)
    }

    return (
        <div id="user-form-container">
            <Link to={"/settings/production_units"}>
                <LeftOutlined />
                Go Back
            </Link>
            <Form form={form} initialValues={productionUnit} onFinish={submit} layout="vertical">
                <div className="card">
                    <div className="card-body">
                        <div>
                            <Row gutter={24}>
                                <Col span={8}>
                                    <Form.Item label="Name" name="name" rules={[{ required: true }]}>
                                        <Input />
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Form.Item>
                                <Button type="primary" htmlType="submit">
                                    Submit
                                </Button>
                            </Form.Item>
                        </div>
                    </div>
                </div>
            </Form>
        </div>
    )
}
